/**
 * Even search filter types
 */
export enum EventFilterType {
  COMMISSION_ID = <any>'commissionId',
  FUNDING_REFERENCE_ID = <any>'fundingReferenceId',
  PAYMENT_REFERENCE_ID = <any>'paymentReferenceId',
  PAYMENT_TYPE = <any>'type',
  DATE_RANGE = <any>'dateRange',
  DATE_AFTER = <any>'dateAfter',
  DATE_BEFORE = <any>'dateBefore',
  GUEST_NAME = <any>'guestName',
  COMPLETED = <any>'eventStatusCompleted',
  MISSING_AGENCY = <any>'eventStatusMissingAgency',
  ARCHIVED = <any>'includeArchivedEvents',
  DELETED = <any>'includeDeletedEvents',
  PAYMENT_STATUS = <any>'paymentStatus',
  COMM_RETENTION = <any>'includeCommRetentionEvents'
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/event-filter-type-enum.ts